import { render } from "./Reting.vue?vue&type=template&id=3c53e36e&scoped=true"
import script from "./Reting.vue?vue&type=script&lang=js"
export * from "./Reting.vue?vue&type=script&lang=js"

import "./Reting.vue?vue&type=style&index=0&id=3c53e36e&lang=scss&scoped=true"

import exportComponent from "D:\\ideaWorkSpace\\政泉\\zhengquan\\sqlpj-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c53e36e"]])

export default __exports__